import { createAutoAnimatePlugin, createAutoHeightTextareaPlugin } from "@formkit/addons";
import { genesisIcons } from "@formkit/icons";
import { createProPlugin, inputs } from "@formkit/pro";
import { generateClasses } from "@formkit/themes";
import { defineFormKitConfig } from "@formkit/vue";
import tailwindTheme from "./formkit-tailwind-theme";

export default defineFormKitConfig(() => {
  const config = useRuntimeConfig();

  return {
    icons: {
      ...genesisIcons,
    },
    config: {
      classes: generateClasses(tailwindTheme),
    },
    plugins: [
      createProPlugin(config.public.formkitProKey, inputs),
      createAutoAnimatePlugin(),
      createAutoHeightTextareaPlugin(),
    ],
    messages: {
      en: {
        validation: {
          required() {
            return "Required";
          },
        },
      },
    },
  };
});
